module.exports = __webpack_public_path__ + "static/media/comp-cooling-s.ab4e74da.webp";